import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { Select } from "@mui/material";
import { Colors } from "../Constant/Color";
import { Select as SelectAntd } from "antd";

const { Option } = SelectAntd;

export default function BasicSelect(prop) {
    let {
        status,
        id,
        value,
        marginTop,
        disabled,
        innerStyle,
        width,
        onChange,
        style,
        placeholder,
        antd=false
    } = prop;

    // const handleChange = (event) => {
    //   setAge(event.target.value);
    // };
    const handleChange = (event) => {
        antd ?onChange(event):onChange(event.target.value)
    };



    return (
        antd?    <div style={{ minWidth: 120, width: width, padding: 0, marginTop: marginTop, ...style }}>
        <SelectAntd
          showSearch
          value={value}
          placeholder={placeholder || status}
          onChange={handleChange}
          disabled={disabled}
          style={{ width: width, fontSize: "14px", fontWeight: "400", ...innerStyle,height:40,textAlign:"left" }}
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          <Option value="select" disabled>
            {status}
          </Option>
          {Object.entries(id).map(([key, val], index) => (
            <Option key={index} value={val}>
              {val}
            </Option>
          ))}
        </SelectAntd>
      </div>
    :<Box sx={{ minWidth: 120, width: width, padding: 0 }}>
            <FormControl size={"small"} sx={{ marginTop: marginTop, display: "flex", alignItems: "center", ...style }} fullWidth>
                <Select
                    id="demo-simple-select"
                    value={value}
                    placeholder={placeholder}
                    // label={status}
                    sx={{ alignSelf: "flex-start", width: width, textAlign: "start", fontSize: "14px", color: Colors.text, fontWeight: "400", ...innerStyle }}
                    onChange={handleChange}
                    disabled={disabled}
                >
                    <MenuItem value="select" disabled>
                        {status} {/* Placeholder text */}
                    </MenuItem>
                    {Object.entries(id).map(([key, value], index) => (
                        <MenuItem key={index} value={value}>
                            {value}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
